export const signUpConfig = {
  defaultCountryCode: "593",
  hideDefaults: true,
  signUpFields: [
    {
      label: "Name",
      key: "name",
      required: true,
      displayOrder: 1,
      type: "string"
    },
    {
      label: "Family name",
      key: "family_name",
      required: true,
      displayOrder: 2,
      type: "string"
    },
    {
      label: "Email",
      key: "email",
      required: true,
      displayOrder: 3,
      type: "email",
      attachRule: "email"
    },
    {
      label: "Phone number",
      key: "phone_number",
      required: true,
      displayOrder: 4,
      type: "string",
      attachRule: "firstnotzero"
    },
    {
      label: "Username",
      key: "username",
      required: true,
      displayOrder: 5,
      type: "string"
    },
    {
      label: "Password",
      key: "password",
      required: true,
      displayOrder: 6,
      type: "password",
      attachRule: "min:6"
    }
  ]
};

export const editUserConfig = {
  defaultCountryCode: "593",
  hideDefaults: true,
  signUpFields: [
    {
      label: "Name",
      key: "name",
      required: true,
      displayOrder: 1,
      type: "string"
    },
    {
      label: "Family name",
      key: "family_name",
      required: true,
      displayOrder: 2,
      type: "string"
    },
    {
      label: "Email",
      key: "email",
      required: true,
      displayOrder: 3,
      type: "email",
      attachRule: "email"
    },
    {
      label: "Phone number",
      key: "phone_number",
      required: true,
      displayOrder: 4,
      type: "string"
    }
  ]
};
